const DATA_TYPE = {
  CHATS: 'chats',
  SUPPORTS: 'supports',
  ACTIONS: 'actions',
  ACTION_AGGREGATES: 'actionAggregates',
  CHAT_VISITS: 'chatVisits',
};

export { DATA_TYPE };
